import React from 'react';

export interface NotificationItem {
  id: string;
  type: 'invite' | 'broadcast' | 'security' | 'peer';
  title: string;
  message: string;
  timestamp: number;
  read: boolean;
}

interface NotificationPopoverProps {
  isOpen: boolean;
  onClose: () => void;
  notifications: NotificationItem[];
  onMarkAllAsRead: () => void;
  onClearNotifications: () => void;
}

export const NotificationPopover: React.FC<NotificationPopoverProps> = ({
  isOpen,
  onClose,
  notifications,
  onMarkAllAsRead,
  onClearNotifications,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 'calc(var(--app-header-height, 48px) + 8px)',
        right: '64px',
        width: '360px',
        maxHeight: '480px',
        backgroundColor: 'var(--theme-bg-card, #151d2a)',
        border: '1px solid var(--theme-border, #1e293b)',
        borderRadius: '12px',
        boxShadow: '0 12px 30px rgba(0,0,0,0.5)',
        zIndex: 100,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        color: 'var(--theme-text-primary, #f8fafc)',
      }}
    >
      {/* Header */}
      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--theme-border, #1e293b)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ fontSize: '14px', fontWeight: 700 }}>
          🔔 Mesh Network Notifications
        </h3>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={onMarkAllAsRead} style={{ background: 'none', border: 'none', color: 'var(--theme-accent, #60a5fa)', cursor: 'pointer', fontSize: '11px', fontWeight: 600 }}>
            Read All
          </button>
          <button onClick={onClearNotifications} style={{ background: 'none', border: 'none', color: 'var(--theme-text-secondary, #94a3b8)', cursor: 'pointer', fontSize: '11px' }}>
            Clear
          </button>
        </div>
      </div>

      {/* List Area */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px' }}>
        {notifications.length === 0 ? (
          <div style={{ padding: '24px 16px', textAlign: 'center', color: 'var(--theme-text-secondary, #64748b)', fontSize: '12px', fontStyle: 'italic' }}>
            No network notifications in inbox
          </div>
        ) : (
          notifications.map((n) => (
            <div
              key={n.id}
              style={{
                padding: '10px 12px',
                borderRadius: '8px',
                marginBottom: '6px',
                backgroundColor: n.read ? 'transparent' : 'rgba(59, 130, 246, 0.1)',
                border: '1px solid var(--theme-border, #1e293b)',
                display: 'flex',
                gap: '10px',
              }}
            >
              <div style={{ fontSize: '16px' }}>
                {n.type === 'invite' ? '✉️' : n.type === 'broadcast' ? '📡' : n.type === 'security' ? '🔒' : '👤'}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--theme-text-primary, #f1f5f9)' }}>
                  {n.title}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--theme-text-secondary, #94a3b8)', marginTop: '2px' }}>
                  {n.message}
                </div>
                <div style={{ fontSize: '10px', color: 'var(--theme-text-secondary, #64748b)', marginTop: '4px' }}>
                  {new Date(n.timestamp).toLocaleTimeString()}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
